import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_SEGMENTS_APP_PATHS } from '../constants/segments-app-paths.constants';
import AdminSegmentDetailsView from '../views/admin/AdminSegmentDetails.view';
import AdminSegmentListView from '../views/admin/AdminSegmentList.view';

export default function AdminSegmentsRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_SEGMENTS_APP_PATHS.SEGMENT_DETAILS(':segmentId')} component={AdminSegmentDetailsView} />
      <Route exact path={ADMIN_SEGMENTS_APP_PATHS.SEGMENTS_LIST} component={AdminSegmentListView} />
    </React.Fragment>
  );
}
